var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{on:{"click":_vm.link}},[(_vm.split)?_c('split-text',{attrs:{"type":'lines',"transition":_vm.transition}},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }